<app-navigation></app-navigation>
<router-outlet></router-outlet>

<app-navigation-footer></app-navigation-footer>